import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'

/** Radio volby v ohraničeném seznamu s popisem. */
export const OptionRadioGroup = ({
  name,
  value,
  onChange,
  options,
}: {
  name: string
  value: string
  onChange: (value: string) => void
  options: { value: string; label: string; description: string }[]
}) => (
  <RadioGroup value={value} onValueChange={onChange} className="gap-0 divide-y overflow-hidden rounded-lg border">
    {options.map((option) => (
      <label
        key={option.value}
        htmlFor={`${name}-${option.value}`}
        className="flex cursor-pointer items-start gap-3 px-4 py-3 transition-colors hover:bg-muted has-[[data-state=checked]]:bg-muted"
      >
        <RadioGroupItem value={option.value} id={`${name}-${option.value}`} className="mt-0.5" />
        <span className="space-y-0.5">
          <span className="block text-sm font-medium">{option.label}</span>
          <span className="block text-sm text-muted-foreground">{option.description}</span>
        </span>
      </label>
    ))}
  </RadioGroup>
)
